module.exports = __webpack_public_path__ + "static/media/eggplant.32ee52a4.png";